document.addEventListener("DOMContentLoaded", function() {
  let anchor = document.getElementById('anchor');
  let anchorTarget = document.getElementById('anchor-target');
  let end = document.getElementById('end');

  let makeInvisible = false;

  let observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
          if(entry.isIntersecting && (entry.target === anchorTarget || entry.target === end)) {
              makeInvisible = true;
          }
      });

      if (makeInvisible) {
          anchor.style.opacity = '0';
          anchor.style.transform = 'translateY(100%)';
      } else {
          anchor.style.opacity = '1';
          anchor.style.transform = 'translateY(0)';
      }

      makeInvisible = false;
  }, 
  { 
    threshold: 0.1 
  });
  
  observer.observe(anchorTarget);
  observer.observe(end);
});
